<shared-header class="search-for-location-hero__pre" [brandAccent]="true" type="5" marginTop="xs" marginBottom="none">
    {{preHead}}</shared-header>
<shared-header [inverted]="true" type="1" marginTop="xs" marginBottom="xs" class="search-for-location-hero__hd">
    <ng-template #searchTitle>
        Find a nearby store to begin your order
    </ng-template>

    <ng-template #deliveryTitle>
        <ng-template #desktop>
            Find a nearby store to deliver your order
        </ng-template>

        <ng-template #mobile>
            Find a nearby store to<br />
            <shared-collection-type-toggle class="search-for-location-hero__inline-drop-down" type="dropdown">
            </shared-collection-type-toggle> your
            order
        </ng-template>
        <projection-for-device [desktop]="desktop" [mobile]="mobile"></projection-for-device>

    </ng-template>

    <ng-container *ngTemplateOutlet="(deliveryTypes$ | async)?.length === 2 ? deliveryTitle : searchTitle">
    </ng-container>
</shared-header>

<shared-search-form [isAutocompleteLocationsEnabled]="isAutocompleteEnabled$ | async" [isDelivery]="isDelivery$ | async"
    class="search-for-location-hero__form" [disabled]="!(hasLocations$ | async)"
    *ngIf="!(isBelowDrawerMediaBreakpoint$ | async)" [value]="searchInput$ | async" [enableSubmit]="enableSubmit"
    [enableClear]="enableClear" [placeholder]="placeholder" (onSearch)="onSearch($event)"
    (onSearchReset)="onSearchReset($event)" mode="hero"></shared-search-form>
